import { render } from "./UpdatePassword.vue?vue&type=template&id=52e22ab4"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"

import "./UpdatePassword.vue?vue&type=style&index=0&id=52e22ab4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UpdatePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52e22ab4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52e22ab4', __exports__)) {
    console.log('reload')
    api.reload('52e22ab4', __exports__)
  }
  
  module.hot.accept("./UpdatePassword.vue?vue&type=template&id=52e22ab4", () => {
    console.log('re-render')
    api.rerender('52e22ab4', render)
  })

}


export default __exports__